import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GridApi } from 'ag-grid-community';
import { ClientGridComponent } from 'src/app/common/client-grid/client-grid.component';
import { CommonService } from 'src/app/services/common.service';
import { EapSummaryService } from 'src/app/services/eap/eap-summary.service';
import { UserService } from 'src/app/services/user.service';
import { EapRegistrationsViewModalComponent } from './eap-registrations-view-modal/eap-registrations-view-modal.component';

@Component({
  selector: 'app-eap-registrations',
  templateUrl: './eap-registrations.component.html',
  styleUrls: ['./eap-registrations.component.scss'],
})
export class EapRegistrationsComponent implements OnInit {

  @ViewChild(ClientGridComponent) clientgrid;
  @Input() public Content: any;

  gridApi: GridApi;
  columnDefs: any[];
  operations: any[];
  Statuslist: any[] = [];
  tempoperations: any[];
  rowData;
  advanceSearch: any;
  selectedRow: any;
  caseDetails: any;
  content: any;
  isSettings: boolean = true;
  moduleType = "EAP";
  Status: string;
  EAPAllRegistartions: UntypedFormGroup;
  Tempoperations: { name: string; id: string; }[];
  Tempoperations1: { name: string; id: string; }[];
  IsResendRequired: boolean = true;
  StatusList: any[] = [];
  UserType: string = "";
  collapesedOrNot: boolean = false;

  /**
   * This constructor is used to initialize the component.
   * It sets the module type based on the route parameter 'type'.
   * If the route parameter is 'eap', module type is set to 'EAP'.
   * If the route parameter is 'ist', module type is set to 'IST'.
   * If the route parameter is not set, module type is set to 'GRANTS'.
   * @param route - The activated route.
   * @param summaryService - The summary service.
   * @param modalService - The modal service.
   * @param commonService - The common service.
   * @param activatedRoute - The activated route.
   * @param userservice - The user service.
   */
  constructor(
    public route: ActivatedRoute,// This is the route parameter that contains the module type used in the component template.
    private summaryService: EapSummaryService,
    private modalService: NgbModal,
    private commonService: CommonService,
    private activatedRoute: ActivatedRoute,
    private userservice: UserService
  ) {
    let pa = this.activatedRoute.snapshot.data['type'];

    if (pa && pa === 'eap') {
      this.moduleType = "EAP";
    } else if (pa && pa === 'ist') {
      this.moduleType = "IST";
    } else {
      this.moduleType = "GRANTS";
    }

    this.activatedRoute.queryParams.subscribe(params => {
      if (params && params.screenName === 'eapRegistrations') {
        this.moduleType = "EAP";
      } else if (params && params.screenName === 'istRegistrations') {
        this.moduleType = "IST";
      } else {
        this.moduleType = "GRANTS";
      }
    })
  }

  /**
   * Initializes the component by retrieving the user type and setting up
   * various form controls and lists. It sets up the status list with
   * predefined status options and initializes the form group for
   * "EAPAllRegistartions" with default values. The method also prepares the
   * column definitions for a grid and sets up an advanced search configuration.
   * Additionally, it invokes the `setSummaryData` method to fetch and display
   * the registration summary data.
   */
  ngOnInit(): void {
    this.UserType = this.userservice.getUserType();
    this.Statuslist.push({ label: "All", value: "" })
    this.Statuslist.push({ label: "Blocked", value: "0" })
    this.Statuslist.push({ label: "Unblocked", value: "1" })

    this.EAPAllRegistartions = new UntypedFormGroup({
      OrganizationName: new UntypedFormControl(""),
      FullName: new UntypedFormControl(""),
      MedicalLicenceNumber: new UntypedFormControl(""),
      City: new UntypedFormControl(""),
      State: new UntypedFormControl(""),
      Country: new UntypedFormControl(""),
      Status: new UntypedFormControl(""),
      ModuleType: new UntypedFormControl(this.moduleType),
    });

    this.StatusList = [{ label: "All", value: "", checked: true }].concat(this.StatusList);

    this.columnDefs = [
      {
        "headerName": "Registration ID",
        "field": "RegistrationID",
      },
      {
        "headerName": "Full Name",
        "field": "FullName"
      },
      {
        "headerName": "Medical Licence Number",
        "field": "MedicalLicenceNumber"
      },
      {
        "headerName": "Organization Name",
        "field": "OrganizationName",
      },
      {
        "headerName": "Status",
        "field": "Status",
      }
    ];

    this.setSummaryData();

    this.advanceSearch =
    {
      "fields": [
        {
          "label": "Organization Name",
          "field": "OrganizationName",
          "type": "text"
        },
        {
          "label": "Full Name",
          "field": "FullName",
          "type": "text"
        },
        {
          "label": "Medical License Number",
          "field": "MedicalLicenceNumber",
          "type": "text"
        },
        {
          "label": "Organization Type",
          "field": "OrganizationType",
          "type": "text"
        },
        {
          "label": "Tax Status",
          "field": "TaxStatus",
          "type": "text"
        }
      ]
    };
  }

  /**
   * Configures row-level operations for each element in the provided row data.
   * Initializes temporary operations lists and updates the operations property
   * of each row element based on specific conditions.
   *
   * @param rowData - An array of row data elements to configure operations for.
   *   Each element can have properties such as 'IsTempPwd' and 'BlockStatus'.
   *
   * Operations added to each row include:
   * - "Edit": Always added to the operations list.
   * - "Resend Email": Added when 'IsTempPwd' is true and 'BlockStatus' equals 1.
   *
   * The function also sets the component's main operations list based on the
   * temporary operations, mapping each operation to a callback function.
   *
   * @returns The modified rowData array with updated operations for each element.
   */
  setRowOperations(rowData: any[]) {
    this.Tempoperations = [];
    this.Tempoperations1 = [];
    this.isSettings = true;

    rowData.forEach(element => {
      this.Tempoperations = [];
      this.Tempoperations.push({
        "name": "Edit",
        "id": "edit"
      });
      if (element.IsTempPwd == true && element.BlockStatus == 1) {
        this.Tempoperations.push(
          {
            "name": "Resend Email",
            "id": "Resend"
          });
      }

      element["Operations"] = this.Tempoperations.map(operation => {
        return operation && operation.id === 'add' ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
      });
    });

    this.operations = this.Tempoperations.map(operation => {
      return operation && operation.id === 'add' ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
    });

    return rowData;
  }

  /**
   * clearCaseDetail() is used to reset the caseDetails array.
   * The caseDetails array is used to display the case details in the grid.
   * The caseDetails array contains two objects.
   * The first object contains the person details.
   * The second object contains the organization details.
   * The caseDetails array is used in the grid to display the case details.
   */
  clearCaseDetail() {
    this.caseDetails = [
      {
        "caseSet": {
          "caseHeading": "",
          "caseData": [
            {
              "label": "Full Name",
              "value": "FullName"
            },
            {
              "label": "Email Address",
              "value": "EmailAdress"
            },
            {
              "label": "Medical License Number",
              "value": "MedicalLicenceNumber"
            },
            {
              "label": "Address",
              "value": "Address"
            }
          ]

        }
      },
      {
        "caseSet": {
          "caseHeading": "Organization Details",
          "caseData": [
            {
              "label": "Email Address",
              "value": "EmailAdress"
            },
            {
              "label": "Name of Organization",
              "value": "OrganizationName"
            },
            {
              "label": "Organization Website",
              "value": "OrganizationWebSite"
            },
            {
              "label": "Address",
              "value": "OrganizationAddress"
            },
            {
              "label": "Institution Tax Number",
              "value": "OrganizationTaxNumber"
            }
          ]

        }
      }
    ];
  }

  /**
   * Retrieves the registration summary data and populates the grid with the same.
   * Also resets the search form and sets the status of the form to empty.
   */
  setSummaryData() {
    this.EAPAllRegistartions.reset();
    this.EAPAllRegistartions.controls["Status"].setValue("");
    this.summaryService.getRegistSummary("api/EAPRegistration/getSummaryData")
      .subscribe({
        next: summary => {
          this.rowData = summary;
          this.setRowOperations(this.rowData);
        }
      });
  }
 
  /**
   * Sets the grid API for the client grid component.
   * This method is called when the grid API is initialized.
   * @param gridApi The grid API instance to be set.
   */
  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }

  /**
   * Executes the callback operation provided in the parameter.
   * @param opr - The operation object containing the callback function to be executed.
   */
  onCallbackOperation(opr) {
    opr.callback();
  }

  /**
   * Called when the selection of a row in the grid is changed.
   * Sets the selectedRow property to the selected row or null if no row is selected.
   * @param event The event object containing the selected row data.
   */
  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  /**
   * Opens the view modal for the selected registration on double click.
   * If the modal is already open, it will not open again.
   * @param event The event object containing the selected registration data.
   */
  onRowDoubleClicked(event) {
    if (!this.modalService.hasOpenModals()) {
      let modelRef = this.modalService.open(EapRegistrationsViewModalComponent, {
        backdrop: false,
        keyboard: false,
        windowClass: 'modal-vlg right modal-right',
        animation: true
      });
      modelRef.componentInstance.Content = {
        heading: 'View',
        content: { id: event.data['ID'], Module: this.moduleType, USERTYPE: this.UserType }
      }
      modelRef.result.then(result => {
        if (result) {
          (this['self'] as EapRegistrationsComponent).setSummaryData();
        }
      });
    }
  }

  /**
   * Opens a modal window for editing a user.
   * The modal is configured with specific settings including window class and animation.
   * Upon completion, the modal result triggers the setSummary function to update the summary data.
   * @param RecordData The data of the row to be edited.
   */
   edit(RecordData: any) { 
    let modalRef = (this['self'] as EapRegistrationsComponent).modalService.open(EapRegistrationsViewModalComponent, {
        backdrop: false,
        keyboard: false,
        windowClass: 'modal-vlg right modal-right',
        animation: true
      });
      modalRef.componentInstance.Content = {
        heading: 'Edit',
      content: {
        id: RecordData['ID'],
        orgID: RecordData['OrganizationID'],
        Module: (this['self'] as EapRegistrationsComponent).moduleType,
        USERTYPE: this.UserType
      }
      };
      modalRef.result.then((result) => {
      (this['self'] as EapRegistrationsComponent).setSummaryData();
      });
    }

  /**
   * Opens a modal window for enrolling a user.
   * The modal is configured with specific settings including window class and animation.
   * Upon completion, the modal result triggers the setSummary function to update the summary data.
   */
  add() {

    let modalRef = this.modalService.open(EapRegistrationsViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-vlg right modal-right',
      animation: true
    });

    modalRef.componentInstance.Content = {
      heading: 'Enroll your',
      content: { USERTYPE: this.UserType }
    }

    modalRef.result.then(result => {
      (this['self'] as EapRegistrationsComponent).setSummaryData();
    });

  }

  /**
   * This function is used to reset the search form and clear the search criteria.
   */
  SearchClear() {
    this.EAPAllRegistartions.reset();
    this.EAPAllRegistartions.controls["Status"].setValue("");
  }

  /**
   * This function is used to search the registrations based on the given criteria.
   * The search criteria are the values given in the form EAPAllRegistartions.
   * The search result is stored in the variable rowData.
   */
  AdvanceSearch() {
    var formDate = this.EAPAllRegistartions.value;
    formDate.ModuleType = this.moduleType;
    this.clientgrid.clearCase(this.caseDetails);

    this.summaryService.fetchSearchData("api/EAPRegistration/SummaryDataSearch", formDate)
      .subscribe({
        next: summary => {
          this.rowData = summary;
        }
      });
  }

  /**
   * Resend the confirmation email to the user.
   *
   * @param {any} RecordData the row data
   * @memberof EapRegistrationsComponent
   */
  Resend(RecordData: any) {
    let id = RecordData["ID"];
    (this['self'] as EapRegistrationsComponent).summaryService.resendUserEmail(id, "1")
      .subscribe({
        next: summary => {
          if (summary != null && summary.Status == 0) {
            (this['self'] as EapRegistrationsComponent).commonService.SuccessBanner(summary.Message);
          } else if (summary.ErrorCode == "MAILEXCEPTION") {
            (this['self'] as EapRegistrationsComponent).commonService.ValidationBanner("Unable to send email to users. Please try again");
          }
        }
      });
  }
}
